<template>
  <div>
    <div v-if="!readOnly" class="ml-2 mr-2 mb-2 mt-2">
      <label>{{ $t('operacoes') }} </label>
      <b-form-select
        class="input-pentagro"
        v-model="operationSelected"
        :options="operations"
      ></b-form-select>
    </div>
    <b-form v-if="operationSelected" class="b-layout">
      <div>
        <div class="inp">
          <label>{{ $t('cons-esp-cao-cana-g-ton') }}</label>
          <input v-model="CE_CaO.value" min="0" type="number" />
        </div>
        <div class="inp">
          <label>{{ $t('grau-baume-be') }}</label>
          <input v-model="Be.value" min="0" type="number" />
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import { SingletonEnginnering } from "../_service/singletonEngineering";
import { ParseToNumber } from "../../utils/tools";
import { SingletonInter } from '../_service/singletonInter';

export default {
  props: {
    node: {
      type: Object,
      default: null,
    },
    readOnly:{
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      attrList: ["CE_CaO", "Be"],
      CE_CaO: {},
      Be: {},
      operations: [{ value: null, text:SingletonInter.$t('selecione-uma-operacao') }],
      operationSelected: null,
      operationAttributeList: [],
      firstLoad: false,
    };
  },

  watch: {
    operationSelected(value) {
      if (this.firstLoad || !value) {
        this.firstLoad = false;
        return;
      }
      this.operationAttributeList = SingletonEnginnering.getOperationsProperties(
        this.operationSelected
      ).filter((operation) => this.attrList.includes(operation.key));

      this.CE_CaO = this.operationAttributeList.find(
        (p) => this.attrList[0] == p.caption
      );
      this.Be = this.operationAttributeList.find(
        (p) => this.attrList[1] == p.caption
      );
      if (this.CE_CaO) this.CE_CaO.value = ParseToNumber(this.CE_CaO.value);
      if (this.Be) this.Be.value = ParseToNumber(this.Be.value);
      this.updateNode();
    },

    "CE_CaO.value"() {
      this.updateNode();
    },
    "Be.value"() {
      this.updateNode();
    },
  },

  methods: {
    loadNode() {
      if (this.node.data[0].index) {
        this.operationSelected = this.node.data[0].index;
        this.firstLoad = true;
      }

      this.node.data.forEach((p) => {
        this.attrList.forEach((a) => {
          if (p.caption == a) {
            p.value = ParseToNumber(p.value);
            this[a] = p;
          }
        });
      });
    },

    updateNode() {
      this.node.attrs = [this.CE_CaO.clone(), this.Be.clone()];
    },

    loadOperation() {
      let optList = SingletonEnginnering.operations.filter((o) =>
        o.match(/RP/)
      );
      this.operations.splice(1);
      optList.forEach((op) => this.operations.push({ value: op, text: op }));
    },
  },

  mounted() {
    this.loadOperation();
    this.loadNode();
  },
};
</script>

<style scoped>
form {
  padding: 10px;
  color: #0009;
}

.b-layout {
  display: flex;
  justify-content: space-between;
}

input {
  margin-left: 5px;
}

.inp {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
